import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { mergeMap, of, map, catchError } from "rxjs";
import { GlobalDataService } from "../../services/faker/global-data.service";
import { ActivityActions } from "./activity.actions";

@Injectable()
export class ActivityEffects {
    constructor(
        private actions$: Actions,
        private globalDataService: GlobalDataService
    ) { }

    loadClasses$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ActivityActions.loadActivities),
            mergeMap(() => {
                const data = this.globalDataService.getActivities();
                if (data && data.length > 0) {
                    return of(data).pipe(
                        map(activities => ActivityActions.loadActivitiesSuccess({ activities })),
                        catchError(error => of(ActivityActions.loadActivitiesFailure({ error })))
                    );
                } else {
                    return of(ActivityActions.loadActivitiesFailure({ error: 'Academic class data not found' }));
                }
            })
        )
    );
}